import {
  REPORTS_LOADING,
  REPORTS_ERROR,

  REPORTS_GET_LIST,
  REPORTS_GET_LIST_NO_PAGINATION,
  REPORTS_GET_FILTERS,
} from "actions/reports/constants";

const initialState = {
  loading: false,
  errors: [],

  list: {},
  listNoPagination: [],
  allFilters: [],
  single: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case REPORTS_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case REPORTS_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case REPORTS_GET_LIST:
      return {
        ...state,
        errors: [],
        loading: false,
        list: action.payload,
      };
    case REPORTS_GET_FILTERS:
      return {
        ...state,
        errors: [],
        loading: false,
        allFilters: action.payload.content,
      };
    case REPORTS_GET_LIST_NO_PAGINATION:
      return {
        ...state,
        errors: [],
        loading: false,
        listNoPagination: action.payload.content,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reportsReducer.js